import CalculatorModal from './CalculatorModal'

export default CalculatorModal
